import {
  isTreeNodeFilterGroup,
  isTreeNodeWithIdFilterGroup,
} from "./isTreeNodeWithIdFilterGroup";
import { FilterTreeNodeWithId } from "../types/common";
import {
  FilterTreeNode,
  ResourceExplorerFilterProvider,
} from "@/services/cloudchipr.api";

export const findFilterProviderInTree = (
  filters: (FilterTreeNodeWithId | FilterTreeNode)[],
): ResourceExplorerFilterProvider | undefined => {
  let provider: ResourceExplorerFilterProvider | undefined;
  filters.forEach((item) => {
    if (provider) {
      return;
    }
    if (!isTreeNodeWithIdFilterGroup(item) && !isTreeNodeFilterGroup(item)) {
      provider = item.filter_provider;
    } else {
      provider = findFilterProviderInTree(item.items);
    }
  });
  return provider;
};
